<template>
  <div class="view-modal">
    <Modal v-model="show" width="980" :title="titleStr" :footer-hide="true">
      <div class="header flex justify-content_end" style="margin-bottom: 10px">
        <Button
          style="margin-right: 10px"
          @click="handlePush"
        >重新推送签约</Button>
        <Button type="primary" @click="handleDown">下载（PDF版）</Button>
      </div>
      <div class="view-pdf" :class="{ opacity: loading }">
        <iframe
          v-show="previewUrl"
          id="ifra"
          ref="Iframe"
          frameborder="0"
          :src="`${previewUrl}?fileId=${fileId}&token=${previewToken}`"
          width="100%"
          style="height: 100%"
        >
        </iframe>
      </div>
      <div class="modal-430-bottom">
        <Button @click="handleBtn">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import cateringAdmin from '@/request/cateringAdmin/index.js';
import platformApi from '@/request/eduCenter/platform.js';
import commonApi from '@/request/common/index.js';

export default {
  data() {
    return {
      previewUrl: '',
      fileId: '',
      previewToken: '',
      downToken: '',
      downUrl: '',
      show: false,
      studentName: '',
      gradeClassName: '',
      orgName: '',
      signId: '',
      loading: true
    };
  },
  computed: {
    titleStr() {
      return `服务签约详情(${this.studentName}_${this.gradeClassName}_${this.orgName})`;
    }
  },
  created() {

  },
  mounted() {
    // this.beforeLoad();
    this.iframeLoad();
  },
  methods: {
    // 下载token
    async getDownloadtoken(fileId) {
      this.fileId = fileId;
      const params = {
        fileId: [fileId],
        type: 1
      };
      this.$Spin.show();
      // const res = await cateringAdmin.getDownloadtoken(params);
      const res = await platformApi.getPreviewServicePdftoken({
        fileId: fileId
      });
      this.$Spin.hide();
      if (res.status == 200) {
        // this.downUrl = res.message.downUrl
        this.previewUrl = res.message.previewUrl;
        this.previewToken = res.message.token;

        // this.downToken = res.message.token
      }
      this.show = true;
    },
    async handlePush() {
      this.$Modal.confirm({
        title: '温馨提示',
        content: '<p>是否要重新推送签约？</p>',
        onOk: () => {
          platformApi.pushMsgToParentReSign({
            signId: this.signId
          }).then(res => {
            if (res.status == 200) {
              this.$Message.success('操作推送成功');
            } else {
              this.$Message.error(res.error);
            }
          });
        },
        onCancel: () => {

        }
      });
    },
    handleBtn() {
      this.show = false;
    },
    beforeLoad() {
      console.log('来到了---34');
      const hasLoaded1 = document.getElementById('iframeLoad');
      if (hasLoaded1) {
        return;
      }
      const meta = document.createElement('meta');
      meta['http-equiv'] = 'Content-Security-Polic';
      meta.content = 'upgrade-insecure-requests';
      meta.id = 'iframeLoad';
      document.head.appendChild(meta);
      console.log('加载了-----432', meta, document.head);
    },
    // iframe
    iframeLoad() {
      const iframe = document.querySelector('#ifra');
      // 兼容处理;
      if (iframe.attachEvent) {
        // IE
        iframe.attachEvent('onload', () => {
          this.loading = false;
        });
      } else {
        // 非IE

        iframe.onload = () => {
          this.loading = false;
        };
      }
    },
    async handleDown() {
      const params = {
        fileId: [this.fileId],
        type: 1
      };
      this.$Spin.show();
      const res = await platformApi.getDownServicePdftoken(params);
      this.$Spin.hide();
      if (res.status == 200) {
        this.downUrl = res.message.downUrl;
        // this.previewUrl = res.message.downUrl
        this.downToken = res.message.token;
        const downloadElement = document.createElement('a');
        const href = `${this.downUrl}?fileId=${this.fileId}&token=${this.downToken}`;
        downloadElement.style.display = 'none';
        downloadElement.href = href;
        downloadElement.download = `${this.studentName}_${this.gradeClassName}_${this.orgName}`; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        document.body.removeChild(downloadElement); // 下载完成移除元素
        window.URL.revokeObjectURL(href); // 释放掉blob对象
      }
    },
    async handleShow(row) {
      const { studentName, gradeClassName, orgName, signId } = row;
      this.studentName = studentName;
      this.gradeClassName = gradeClassName;
      this.orgName = orgName;
      this.signId = signId;
      this.getDownloadtoken(row.signFileId);
    }
  }
};
</script>

<style  lang="scss" scoped>
.view-pdf {
  height: 65vh;
  position: relative;
  margin-bottom: 20px;
}
.view-modal {
  .iframe-main {
    height: 100%;
    position: relative;
  }
  .opacity {
    opacity: 0;
  }
  .modal-footer {
    text-align: right;
    padding: 10px 0;
  }
}
</style>
